import React, { useEffect } from "react";
import { IItinerary, useConfig } from "@thekilroygroup/shared-ui";
import {
  IGoogleTrackingData,
  ITravellerAmount,
  findTravellerAmount,
  googleFlightsFindItems,
  googleFlightsTripTypeMap,
} from "./metaUtils";
import { getCurrency } from "utils/numberUtils";
import { useLocation } from "react-router-dom";

interface IProps {
  selectedItinerary: IItinerary | null;
  fareId: string | null;
  eventType: "pre-conversion" | "conversion";
  price: number;
  googlePartnerId: string;
  isDirectBooking?: boolean;
}

declare global {
  interface Window {
    gtag: any; // Replace 'any' with the actual type of 'gtag' if available
  }
}
export const GoogleFlightsTracking = (props: IProps) => {
  const {
    selectedItinerary,
    eventType,
    price,
    googlePartnerId,
    isDirectBooking = false,
  } = props;

  const { pathname } = useLocation();
  const {
    appConfig: { ENVIRONMENT },
  } = useConfig() as { appConfig: { ENVIRONMENT: string } };

  // const logTracking = (trackingObj: any, eventType: string) => {
  //   console.log(
  //     `\n%c---------------------------------------------\n%c🤖 Metapartner tracking is disabled in dev environments 🤖\n%cIn production, tracking is fired to google flights with the following object:\n`,
  //     "color: #FF3C00; font-size: 18px;",
  //     "color: #FF3C00; font-size: 18px;",
  //     "color: black; font-size: 12px;"
  //   );
  //   const objWithEventType = { ...trackingObj, eventType: eventType };
  //   console.table(objWithEventType);
  // };

  useEffect(() => {
    if (
      window.gtag &&
      eventType === "pre-conversion" &&
      (pathname === "/checkout" || pathname === "/search-redirect")
    ) {
      if (selectedItinerary) {
        const trackingObject: any = {
          send_to: googlePartnerId,
          value: price,
          currency: selectedItinerary ? getCurrency(selectedItinerary) : "_",
          is_direct_booking: isDirectBooking,
        };
        // Only log tracking in dev environments
        // if (ENVIRONMENT.toLocaleLowerCase() !== "prod") {
        //   logTracking(trackingObject, "view_item");
        // } else {
        //   window.gtag("event", "view_item", trackingObject);
        // }

        // Always log tracking in all environments
        window.gtag("event", "view_item", trackingObject);
      } else {
        const trackingObject: any = {
          send_to: googlePartnerId,
          flight_error_code: "FLIGHT_NOT_FOUND",
          is_direct_booking: isDirectBooking,
        };

        // Only log tracking in dev environments
        //  if (ENVIRONMENT.toLocaleLowerCase() !== "prod") {
        //           logTracking(trackingObject, "view_item");
        //         } else {
        //           window.gtag("event", "view_item", trackingObject);
        //         }

        // Always log tracking in all environments
        window.gtag("event", "view_item", trackingObject);
      }
    } else if (window.gtag && eventType === "conversion" && selectedItinerary) {
      const travellers: ITravellerAmount =
        findTravellerAmount(selectedItinerary);

      const googleTrackingObject: IGoogleTrackingData = {
        send_to: googlePartnerId,
        value: String(selectedItinerary?.totalFareAmounts.total),
        currency: selectedItinerary ? getCurrency(selectedItinerary) : "_",

        trip_type:
          googleFlightsTripTypeMap[selectedItinerary?.tripType] || "Other",
        passengers: {
          total: travellers.total,
          adult: travellers.adults,
          child: travellers.children,
          infant_in_seat: travellers.infants,
          infant_in_lap: 0,
        },
        items: googleFlightsFindItems(selectedItinerary),
      };

      // Only log tracking in dev environments
      // if (ENVIRONMENT.toLocaleLowerCase() !== "prod") {
      //         logTracking(googleTrackingObject, "purchase");
      //       } else {
      //         window.gtag("event", "purchase", googleTrackingObject);
      //       }

      // Always log tracking in all environments
      window.gtag("event", "purchase", googleTrackingObject);
    }
  });

  return <></>;
};
